import { Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from 'beam'
import { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Row } from './Row'
import { LoginMethod } from './loginApi'
import { SubmissionValueDisplay } from './SubmissionValueDisplay'

export type LoginMethodChoice = Exclude<LoginMethod, 'choice'>

export interface ChooseLoginMethodProps {
  email: string,
  onCancel: () => void,
  onSubmit: (selectedLoginMethod: LoginMethodChoice) => void,
}

export function ChooseLoginMethod({ email, onCancel, onSubmit }: ChooseLoginMethodProps): ReactElement {
  const [selectedLoginMethod, setSelectedLoginMethod] = useState<LoginMethodChoice>('classic')
  const { t } = useTranslation()
  const formSubmitHandler = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault()
    selectedLoginMethod && onSubmit(selectedLoginMethod) // can never submit when null because submit button is disabled
  }
  return <form onSubmit={formSubmitHandler}>
    <Row>
      <SubmissionValueDisplay name={t('email')}>{email}</SubmissionValueDisplay>
    </Row>
    <Row>
      <FormControl>
        <FormLabel>{t('selectSignInExpLabel')}</FormLabel>
        <RadioGroup value={selectedLoginMethod} onChange={(event, value: LoginMethodChoice) => setSelectedLoginMethod(value)}>
          <FormControlLabel value="classic" control={<Radio data-testid="LoginMethod-Classic" />} label={t('classicCalabrioOneLabel')} />
          <FormControlLabel value="external" control={<Radio data-testid="LoginMethod-External" />} label={t('newCalabrioOneLabel')} />
        </RadioGroup>
      </FormControl>
    </Row>
    <Row>
      <Button type="submit" variant="contained" color="secondary" disabled={!selectedLoginMethod} data-testid="LoginMethod-LoginButton">
        {t('next')}
      </Button>
      <Button variant="text" onClick={onCancel} data-testid="LoginMethod-CancelButton">
        {t('cancel')}
      </Button>
    </Row>
  </form>
}
